import React from 'react';
import Paypal from 'gatsby-plugin-paypal';

/* for customizatioin see
  https://developer.paypal.com/docs/checkout/integration-features/customize-button/ and
  https://www.gatsbyjs.com/plugins/gatsby-plugin-paypal/
*/

interface PaypalButtonProps {
  label?: string;
  amount: number;
  currency?: 'USD' | 'EUR';
  createOrder: (data: any, actions: any) => any;
  onApprove: (data: any, actions: any) => any;
  onInit: (data: any, actions: any) => any
}

const PaylpalButton = ({ label='pay', amount, currency='USD', ...otherProps }: PaypalButtonProps) => (
    <Paypal 
      style={{
        shape: 'rect',
        color: 'gold',
        layout: 'horizontal',
        label,
      }}
      amount={amount}
      currency={currency}
      {...otherProps}
    />
)

export default PaylpalButton;